// Translations for GPT-related UI components
// Supports: English, Hebrew, Russian, Spanish, Arabic

const translations = {
  english: {
    // GPT Settings
    "gptAssistantSettings": "GPT Assistant Settings",
    "enableGPTAssistant": "Enable GPT Assistant",
    "functionality": "Functionality",
    "functionalitySales": "Sales",
    "functionalitySupport": "Support",
    "functionalityBoth": "Both",
    "tone": "Tone",
    "toneFormal": "Formal",
    "toneCasual": "Casual",
    "toneFriendly": "Friendly",
    "language": "Language",
    "languageNone": "None",
    "languageEnglish": "English",
    "languageHebrew": "Hebrew (עברית)",
    "languageRussian": "Russian (Русский)",
    "languageSpanish": "Spanish (Español)",
    "languageArabic": "Arabic (العربية)",
    "languageOverride": "Language Override",
    "languageOverrideDescription": "By default, GPT automatically detects the conversation language. Enable override to force a specific language for all GPT responses.",
    "enableLanguageOverride": "Enable Language Override",
    "overrideLanguage": "Override Language",
    "assistanceLevel": "AI Assistance Level",
    "assistanceSuggestions": "Suggestions Only",
    "assistanceSemiAuto": "Semi-Automatic",
    "assistanceFull": "Full (Manual Approval Required)",
    "modes": "Modes (Multi-select)",
    "modeSupport": "Support Mode",
    "modeSales": "Sales Mode",
    "modeAnalytics": "Analytics Mode",
    "languages": "Languages",
    "routing": "Logic Routing",
    "routingSupport": "Link GPT to Customer Support Area",
    "routingSales": "Link GPT to Sales Area",
    "routingAnalytics": "Link GPT to Analytics Area",
    "customPrompt": "Custom Prompt",
    "customPromptDescription": "Add global instructions that will be appended to all GPT prompts. Use template variables like {{customer.name}}, {{trip.date}} for personalization.",
    "customPromptPlaceholder": "Example: Always mention our brand 'TravelPro'. Never promise discounts without approval. Use only facts from the system.",
    "customPromptHelper": "This prompt will be added to all GPT responses. Leave empty to use default prompts only.",
    "managerAlert": "Manager Alert Settings",
    "managerAlertDescription": "Enter the phone number that will receive automatic escalation alerts. The number should be in international format (e.g., +1234567890).",
    "managerAlertPhone": "Manager Alert Phone Number",
    "managerAlertPlaceholder": "+1234567890",
    "managerAlertHelper": "Phone number for receiving escalation alerts (optional)",
    "permissions": "Permissions",
    "permissionsDescription": "Define which users or departments can use GPT assistant.",
    "audience": "Audience",
    "audienceAll": "All Users",
    "audienceRoles": "Specific Roles",
    "audienceDepartments": "Specific Departments",
    "audienceUsers": "Specific Users",
    "selectSpecificBelow": "Select specific {audience} below",
    "selectRoles": "Select Roles",
    "selectUsers": "Select Users",
    "selectDepartments": "Select Departments (Queues)",
    "noDepartmentsAvailable": "No departments (queues) available.",
    "createQueuesFirst": "Please create queues in the <strong>Queues</strong> section first.",
    "departmentsAvailable": "{count} department(s) available",
    "noDepartmentsFound": "No departments found",
    "supportSettings": "Support Settings",
    "maxReplyLength": "Max Reply Length (chars)",
    "humanApprovalOnly": "Human Approval Only (default)",
    "salesSettings": "Sales Settings",
    "enableUpsell": "Enable Upsell Suggestions",
    "maxOptions": "Max Options",
    "toneIntensity": "Tone Intensity",
    "toneIntensitySoft": "Soft",
    "toneIntensityMedium": "Medium",
    "toneIntensityAssertive": "Assertive",
    "analyticsSettings": "Analytics Settings",
    "summaryLength": "Summary Length",
    "summaryShort": "Short",
    "summaryMedium": "Medium",
    "summaryLong": "Long",
    "redactPII": "Redact PII (Personal Information)",
    "detectKeyIssues": "🔍 Detect Key Issues",
    "saveSettings": "Save Settings",
    
    // GPT Analytics
    "gptAnalytics": "GPT Analytics",
    "analyticsDashboard": "Analytics Dashboard",
    "analyticsDescription": "Use GPT-powered analytics to gain insights into your customer support operations. Analyze conversations, detect patterns, and improve agent performance.",
    "keyIssuesDetection": "Key Issues Detection",
    "keyIssuesDescription": "Analyze multiple conversations to identify recurring issues, patterns, and problems across your support tickets.",
    "agentPerformanceInsights": "Agent Performance Insights",
    "agentPerformanceDescription": "View detailed performance metrics for agents including response time, missed messages, and effectiveness.",
    "openAnalysis": "Open Analysis",
    "quickAccess": "Quick Access",
    "quickAccessKeyIssues": "• <strong>Key Issues:</strong> Go to Settings → GPT → Analytics Settings → Detect Key Issues",
    "quickAccessAgentPerformance": "• <strong>Agent Performance:</strong> Go to Users → Click \"View Performance\" on any user",
    "quickAccessConversationSummary": "• <strong>Conversation Summary:</strong> Open any ticket → Click the document icon",
    "quickAccessSentimentTrends": "• <strong>Sentiment Trends:</strong> Open any ticket → Click the chart icon",
    
    // GPT Suggestions Modal
    "gptSuggestions": "✨ GPT Suggestions",
    "customPromptOptional": "Custom Prompt (optional)",
    "customPromptPlaceholderModal": "Enter a custom prompt to guide GPT suggestions. Use {{customer.name}}, {{trip.date}} for template variables.",
    "customPromptHelperModal": "This prompt will override the default prompt for this request.",
    "generating": "Generating...",
    "generateSuggestions": "Generate Suggestions",
    "generatingSuggestions": "Generating suggestions...",
    "noSuggestionsAvailable": "No suggestions available.",
    "enterPromptAndClick": "Enter a prompt and click 'Generate Suggestions' to get started.",
    "confidence": "Confidence: {percent}%",
    "quickActions": "Quick Actions:",
    
    // Conversation Summary Modal
    "conversationSummary": "Conversation Summary",
    "shortSummary": "SHORT SUMMARY",
    "extendedSummary": "EXTENDED SUMMARY",
    "generatingSummary": "Generating {type} summary...",
    "sentiment": "Sentiment: {sentiment}",
    "keyPoints": "Key Points",
    "mainTopics": "Main Topics",
    "resolution": "Resolution",
    "nextActions": "Next Actions",
    "noSummaryAvailable": "No summary available.",
    
    // Sentiment Trends Modal
    "sentimentTrends": "📈 Sentiment Trends",
    "analyzingSentimentTrends": "Analyzing sentiment trends...",
    "start": "Start: {sentiment}",
    "end": "End: {sentiment}",
    "trendLabel": "Trend: {trend}",
    "sentimentProgression": "Sentiment Progression",
    "agent": "Agent",
    "customer": "Customer",
    "confidencePercent": "Confidence: {percent}%",
    "keyMoments": "Key Moments",
    "noSentimentDataAvailable": "No sentiment data available.",
    
    // Sales Opportunities Modal
    "salesOpportunities": "Sales Opportunities",
    "analyzingSalesOpportunities": "Analyzing conversation for sales opportunities...",
    "noOpportunitiesFound": "No opportunities found in this conversation.",
    "opportunityType": "Type",
    "readiness": "Readiness",
    "confidenceLabel": "Confidence",
    "reasoning": "Reasoning",
    "recommendedActions": "Recommended Actions",
    "suggestedMessage": "Suggested Message",
    "upsell": "Upsell",
    "crossSell": "Cross-sell",
    "newProduct": "New Product",
    "upgrade": "Upgrade",
    "addon": "Add-on",
    "ready": "Ready",
    "interested": "Interested",
    "notReady": "Not Ready",
    "unknown": "Unknown",
    
    // File Analysis Modal
    "gptFileAnalysis": "📄 GPT File Analysis",
    "analyzingFileWithGPT": "Analyzing file with GPT...",
    "noAnalysisAvailable": "No analysis available.",
    
    // Agent Performance Modal
    "agentPerformance": "Agent Performance",
    "overview": "OVERVIEW",
    "trends": "TRENDS",
    "overallPerformanceScore": "Overall Performance Score",
    "responseTimeMetrics": "Response Time Metrics",
    "missedMessagesMetrics": "Missed Messages Metrics",
    "effectivenessMetrics": "Effectiveness Metrics",
    "sentimentPerformance": "Sentiment Performance",
    "efficiencyProductivity": "Efficiency & Productivity",
    "customerExperienceIndicators": "Customer Experience Indicators",
    "opportunityHandling": "Opportunity Handling",
    "analyzingAgentPerformance": "Analyzing agent performance...",
    "retry": "Retry",
    "analyze": "Analyze",
    "clickAnalyzeToLoad": "Click \"Analyze\" to load performance metrics",
    "excellent": "Excellent",
    "veryGood": "Very Good",
    "good": "Good",
    "fair": "Fair",
    "needsImprovement": "Needs Improvement",
    "average": "Average",
    "median": "Median",
    "fastest": "Fastest",
    "slowest": "Slowest",
    "firstResponseAvg": "First Response (Avg)",
    "longestDelay": "Longest Delay",
    "delayedResponses": "Delayed Responses (>5m)",
    "totalMissed": "Total Missed",
    "avgPerTicket": "Avg per Ticket",
    "longestGap": "Longest Gap",
    "unansweredQuestions": "Unanswered Questions",
    "followUpReminders": "Follow-up Reminders",
    "managerAlerts": "Manager Alerts",
    "ticketsResolved": "Tickets Resolved",
    "resolutionRate": "Resolution Rate",
    "avgResolutionTime": "Avg Resolution Time",
    "firstContactResolution": "First Contact Resolution",
    "escalationRate": "Escalation Rate",
    "ticketsEscalated": "Tickets Escalated",
    "ticketsUnresolved": "Tickets Unresolved",
    "negativeEndings": "Negative Endings",
    "resolved": "Resolved",
    "escalated": "Escalated",
    "unresolved": "Unresolved",
    "positive": "Positive",
    "neutral": "Neutral",
    "negative": "Negative",
    "recoveryRate": "Recovery Rate",
    "trend": "Trend",
    "declining": "declining",
    "improving": "improving",
    "stable": "stable",
    "opportunitiesDetected": "Opportunities Detected",
    "opportunitiesMissed": "Opportunities Missed",
    "followUpsUsed": "Follow-ups Used",
    "avgConversionLikelihood": "Avg Conversion Likelihood",
    "repeatedQuestions": "Repeated Questions",
    "confusionCases": "Confusion Cases",
    "backAndForthLoops": "Back-and-Forth Loops",
    "avgExchangesPerTicket": "Avg Exchanges/Ticket",
    "totalConversations": "Total Conversations",
    "active": "Active",
    "passive": "Passive",
    "avgMessageLength": "Avg Message Length",
    "multitaskingScore": "Multitasking Score",
    "responseDistribution": "Response Distribution",
    "ticketsWithMissedMessages": "Tickets with missed messages",
    "close": "CLOSE",
    "exportPDF": "EXPORT PDF",
    "exportJSON": "EXPORT JSON",
    "refresh": "REFRESH",
    "user": "User",
    "sentimentTrendOverTime": "Sentiment Trend Over Time",
    "responseTimeDistribution": "Response Time Distribution",
    "successRateBreakdown": "Success Rate Breakdown",
    "recommendations": "Recommendations",
    "period": "Period",
    "avgConcurrentChats": "Avg Concurrent Chats",
    "lessThan1Min": "< 1 min",
    "lessThan5Min": "< 5 min",
    "moreThan15Min": "> 15 min",
  },
  
  hebrew: {
    "gptAssistantSettings": "הגדרות עוזר GPT",
    "enableGPTAssistant": "הפעל עוזר GPT",
    "functionality": "פונקציונליות",
    "functionalitySales": "מכירות",
    "functionalitySupport": "תמיכה",
    "functionalityBoth": "שניהם",
    "tone": "טון",
    "toneFormal": "פורמלי",
    "toneCasual": "לא פורמלי",
    "toneFriendly": "ידידותי",
    "language": "שפה",
    "languageNone": "ללא",
    "languageEnglish": "אנגלית",
    "languageHebrew": "עברית (עברית)",
    "languageRussian": "רוסית (Русский)",
    "languageSpanish": "ספרדית (Español)",
    "languageArabic": "ערבית (العربية)",
    "languageOverride": "דריסת שפה",
    "languageOverrideDescription": "כברירת מחדל, GPT מזהה אוטומטית את שפת השיחה. הפעל דריסה כדי לכפות שפה ספציפית לכל תגובות GPT.",
    "enableLanguageOverride": "הפעל דריסת שפה",
    "overrideLanguage": "שפת דריסה",
    "assistanceLevel": "רמת סיוע AI",
    "assistanceSuggestions": "הצעות בלבד",
    "assistanceSemiAuto": "חצי אוטומטי",
    "assistanceFull": "מלא (נדרש אישור ידני)",
    "modes": "מצבים (בחירה מרובה)",
    "modeSupport": "מצב תמיכה",
    "modeSales": "מצב מכירות",
    "modeAnalytics": "מצב אנליטיקה",
    "languages": "שפות",
    "routing": "ניתוב לוגי",
    "routingSupport": "קשר GPT לאזור תמיכה ללקוחות",
    "routingSales": "קשר GPT לאזור מכירות",
    "routingAnalytics": "קשר GPT לאזור אנליטיקה",
    "customPrompt": "פקודה מותאמת אישית",
    "customPromptDescription": "הוסף הוראות גלובליות שיתווספו לכל הפקודות של GPT. השתמש במשתני תבנית כמו {{customer.name}}, {{trip.date}} להתאמה אישית.",
    "customPromptPlaceholder": "דוגמה: תמיד ציין את המותג שלנו 'TravelPro'. לעולם אל תבטח הנחות ללא אישור. השתמש רק בעובדות מהמערכת.",
    "customPromptHelper": "פקודה זו תתווסף לכל תגובות GPT. השאר ריק כדי להשתמש רק בפקודות ברירת מחדל.",
    "managerAlert": "הגדרות התראת מנהל",
    "managerAlertDescription": "הזן את מספר הטלפון שיקבל התראות הסלמה אוטומטיות. המספר צריך להיות בפורמט בינלאומי (למשל, +1234567890).",
    "managerAlertPhone": "מספר טלפון התראת מנהל",
    "managerAlertPlaceholder": "+1234567890",
    "managerAlertHelper": "מספר טלפון לקבלת התראות הסלמה (אופציונלי)",
    "permissions": "הרשאות",
    "permissionsDescription": "הגדר אילו משתמשים או מחלקות יכולים להשתמש בעוזר GPT.",
    "audience": "קהל יעד",
    "audienceAll": "כל המשתמשים",
    "audienceRoles": "תפקידים ספציפיים",
    "audienceDepartments": "מחלקות ספציפיות",
    "audienceUsers": "משתמשים ספציפיים",
    "selectSpecificBelow": "בחר {audience} ספציפיים למטה",
    "selectRoles": "בחר תפקידים",
    "selectUsers": "בחר משתמשים",
    "selectDepartments": "בחר מחלקות (תורים)",
    "noDepartmentsAvailable": "אין מחלקות (תורים) זמינות.",
    "createQueuesFirst": "אנא צור תורים בסעיף <strong>תורים</strong> תחילה.",
    "departmentsAvailable": "{count} מחלקה(ות) זמינה(ות)",
    "noDepartmentsFound": "לא נמצאו מחלקות",
    "supportSettings": "הגדרות תמיכה",
    "maxReplyLength": "אורך תגובה מקסימלי (תווים)",
    "humanApprovalOnly": "אישור אנושי בלבד (ברירת מחדל)",
    "salesSettings": "הגדרות מכירות",
    "enableUpsell": "הפעל הצעות מכירה נוספת",
    "maxOptions": "אפשרויות מקסימליות",
    "toneIntensity": "עוצמת טון",
    "toneIntensitySoft": "רך",
    "toneIntensityMedium": "בינוני",
    "toneIntensityAssertive": "נחרץ",
    "analyticsSettings": "הגדרות אנליטיקה",
    "summaryLength": "אורך סיכום",
    "summaryShort": "קצר",
    "summaryMedium": "בינוני",
    "summaryLong": "ארוך",
    "redactPII": "הסתר מידע אישי (PII)",
    "detectKeyIssues": "🔍 זהה בעיות מפתח",
    "saveSettings": "שמור הגדרות",
    "gptAnalytics": "אנליטיקת GPT",
    "analyticsDashboard": "לוח בקרה אנליטי",
    "analyticsDescription": "השתמש באנליטיקה מונעת GPT כדי לקבל תובנות על פעולות תמיכה ללקוחות. נתח שיחות, זהה דפוסים ושפר ביצועי סוכנים.",
    "keyIssuesDetection": "זיהוי בעיות מפתח",
    "keyIssuesDescription": "נתח שיחות מרובות כדי לזהות בעיות חוזרות, דפוסים ובעיות בפניות התמיכה שלך.",
    "agentPerformanceInsights": "תובנות ביצועי סוכנים",
    "agentPerformanceDescription": "צפה במדדי ביצועים מפורטים עבור סוכנים כולל זמן תגובה, הודעות שהוחמצו ויעילות.",
    "openAnalysis": "פתח ניתוח",
    "quickAccess": "גישה מהירה",
    "quickAccessKeyIssues": "• <strong>בעיות מפתח:</strong> עבור להגדרות → GPT → הגדרות אנליטיקה → זהה בעיות מפתח",
    "quickAccessAgentPerformance": "• <strong>ביצועי סוכן:</strong> עבור למשתמשים → לחץ על \"צפה בביצועים\" על כל משתמש",
    "quickAccessConversationSummary": "• <strong>סיכום שיחה:</strong> פתח כל קריאה → לחץ על סמל המסמך",
    "quickAccessSentimentTrends": "• <strong>מגמות סנטימנט:</strong> פתח כל קריאה → לחץ על סמל התרשים",
    "gptSuggestions": "✨ הצעות GPT",
    "customPromptOptional": "פקודה מותאמת אישית (אופציונלי)",
    "customPromptPlaceholderModal": "הזן פקודה מותאמת אישית להנחיית הצעות GPT. השתמש במשתני תבנית כמו {{customer.name}}, {{trip.date}}.",
    "customPromptHelperModal": "פקודה זו תדרוס את הפקודה ברירת המחדל לבקשה זו.",
    "generating": "מייצר...",
    "generateSuggestions": "צור הצעות",
    "generatingSuggestions": "מייצר הצעות...",
    "noSuggestionsAvailable": "אין הצעות זמינות.",
    "enterPromptAndClick": "הזן פקודה ולחץ על 'צור הצעות' כדי להתחיל.",
    "confidence": "ביטחון: {percent}%",
    "quickActions": "פעולות מהירות:",
    "conversationSummary": "סיכום שיחה",
    "shortSummary": "סיכום קצר",
    "extendedSummary": "סיכום מורחב",
    "generatingSummary": "מייצר סיכום {type}...",
    "sentiment": "סנטימנט: {sentiment}",
    "keyPoints": "נקודות מפתח",
    "mainTopics": "נושאים עיקריים",
    "resolution": "פתרון",
    "nextActions": "פעולות הבאות",
    "noSummaryAvailable": "אין סיכום זמין.",
    "sentimentTrends": "📈 מגמות סנטימנט",
    "analyzingSentimentTrends": "מנתח מגמות סנטימנט...",
    
    // Agent Performance Modal
    "agentPerformance": "ביצועי סוכן",
    "overview": "סקירה כללית",
    "trends": "מגמות",
    "overallPerformanceScore": "ציון ביצועים כולל",
    "responseTimeMetrics": "מדדי זמן תגובה",
    "missedMessagesMetrics": "מדדי הודעות שהוחמצו",
    "effectivenessMetrics": "מדדי יעילות",
    "sentimentPerformance": "ביצועי סנטימנט",
    "efficiencyProductivity": "יעילות ופרודוקטיביות",
    "customerExperienceIndicators": "אינדיקטורים לחוויית לקוח",
    "opportunityHandling": "טיפול בהזדמנויות",
    "analyzingAgentPerformance": "מנתח ביצועי סוכן...",
    "retry": "נסה שוב",
    "analyze": "נתח",
    "clickAnalyzeToLoad": "לחץ על \"נתח\" כדי לטעון מדדי ביצועים",
    "excellent": "מצוין",
    "veryGood": "טוב מאוד",
    "good": "טוב",
    "fair": "הוגן",
    "needsImprovement": "זקוק לשיפור",
    "average": "ממוצע",
    "median": "חציון",
    "fastest": "המהיר ביותר",
    "slowest": "האיטי ביותר",
    "firstResponseAvg": "תגובה ראשונה (ממוצע)",
    "longestDelay": "עיכוב ארוך ביותר",
    "delayedResponses": "תגובות מעוכבות (>5 דקות)",
    "totalMissed": "סה\"כ הוחמצו",
    "avgPerTicket": "ממוצע לכל כרטיס",
    "longestGap": "פער ארוך ביותר",
    "unansweredQuestions": "שאלות ללא מענה",
    "followUpReminders": "תזכורות מעקב",
    "managerAlerts": "התראות מנהל",
    "ticketsResolved": "כרטיסים שנפתרו",
    "resolutionRate": "שיעור פתרון",
    "avgResolutionTime": "זמן פתרון ממוצע",
    "firstContactResolution": "פתרון במגע ראשון",
    "escalationRate": "שיעור הסלמה",
    "ticketsEscalated": "כרטיסים שהוסלמו",
    "ticketsUnresolved": "כרטיסים שלא נפתרו",
    "negativeEndings": "סיומים שליליים",
    "resolved": "נפתר",
    "escalated": "הוסלם",
    "unresolved": "לא נפתר",
    "positive": "חיובי",
    "neutral": "ניטרלי",
    "negative": "שלילי",
    "recoveryRate": "שיעור התאוששות",
    "trend": "מגמה",
    "declining": "יורד",
    "improving": "משתפר",
    "stable": "יציב",
    "opportunitiesMissed": "הזדמנויות שהוחמצו",
    "followUpsUsed": "מעקבים שנעשה בהם שימוש",
    "avgConversionLikelihood": "סבירות המרה ממוצעת",
    "repeatedQuestions": "שאלות חוזרות",
    "confusionCases": "מקרי בלבול",
    "backAndForthLoops": "לולאות הלוך ושוב",
    "avgExchangesPerTicket": "חילופי דברים ממוצעים/כרטיס",
    "totalConversations": "סה\"כ שיחות",
    "active": "פעיל",
    "passive": "פסיבי",
    "avgMessageLength": "אורך הודעה ממוצע",
    "multitaskingScore": "ציון ריבוי משימות",
    "responseDistribution": "התפלגות תגובות",
    "ticketsWithMissedMessages": "כרטיסים עם הודעות שהוחמצו",
    "close": "סגור",
    "exportPDF": "ייצא PDF",
    "exportJSON": "ייצא JSON",
    "refresh": "רענן",
    "user": "משתמש",
    "sentimentTrendOverTime": "מגמת סנטימנט לאורך זמן",
    "responseTimeDistribution": "התפלגות זמן תגובה",
    "successRateBreakdown": "פירוט שיעור הצלחה",
    "recommendations": "המלצות",
    "period": "תקופה",
    "avgConcurrentChats": "צ'אטים מקבילים ממוצעים",
    "lessThan1Min": "< 1 דקה",
    "lessThan5Min": "< 5 דקות",
    "moreThan15Min": "> 15 דקות",
    "start": "התחלה: {sentiment}",
    "end": "סיום: {sentiment}",
    "trendLabel": "מגמה: {trend}",
    "sentimentProgression": "התקדמות סנטימנט",
    "agent": "סוכן",
    "customer": "לקוח",
    "confidencePercent": "ביטחון: {percent}%",
    "keyMoments": "רגעים מפתח",
    "noSentimentDataAvailable": "אין נתוני סנטימנט זמינים.",
    "salesOpportunities": "הזדמנויות מכירות",
    "analyzingSalesOpportunities": "מנתח שיחה להזדמנויות מכירות...",
    "opportunitiesDetected": "הזדמנויות שזוהו",
    "noOpportunitiesFound": "לא נמצאו הזדמנויות בשיחה זו.",
    "opportunityType": "סוג",
    "readiness": "מוכנות",
    "confidenceLabel": "ביטחון",
    "reasoning": "נימוק",
    "recommendedActions": "פעולות מומלצות",
    "suggestedMessage": "הודעה מוצעת",
    "upsell": "מכירה נוספת",
    "crossSell": "מכירה צולבת",
    "newProduct": "מוצר חדש",
    "upgrade": "שדרוג",
    "addon": "תוסף",
    "ready": "מוכן",
    "interested": "מעוניין",
    "notReady": "לא מוכן",
    "unknown": "לא ידוע",
    "gptFileAnalysis": "📄 ניתוח קובץ GPT",
    "analyzingFileWithGPT": "מנתח קובץ עם GPT...",
    "noAnalysisAvailable": "אין ניתוח זמין.",
  },
  
  russian: {
    "gptAssistantSettings": "Настройки помощника GPT",
    "enableGPTAssistant": "Включить помощника GPT",
    "functionality": "Функциональность",
    "functionalitySales": "Продажи",
    "functionalitySupport": "Поддержка",
    "functionalityBoth": "Оба",
    "tone": "Тон",
    "toneFormal": "Формальный",
    "toneCasual": "Неформальный",
    "toneFriendly": "Дружелюбный",
    "language": "Язык",
    "languageNone": "Нет",
    "languageEnglish": "Английский",
    "languageHebrew": "Иврит (עברית)",
    "languageRussian": "Русский (Русский)",
    "languageSpanish": "Испанский (Español)",
    "languageArabic": "Арабский (العربية)",
    "languageOverride": "Переопределение языка",
    "languageOverrideDescription": "По умолчанию GPT автоматически определяет язык разговора. Включите переопределение, чтобы принудительно использовать определенный язык для всех ответов GPT.",
    "enableLanguageOverride": "Включить переопределение языка",
    "overrideLanguage": "Язык переопределения",
    "assistanceLevel": "Уровень помощи ИИ",
    "assistanceSuggestions": "Только предложения",
    "assistanceSemiAuto": "Полуавтоматический",
    "assistanceFull": "Полный (требуется ручное одобрение)",
    "modes": "Режимы (множественный выбор)",
    "modeSupport": "Режим поддержки",
    "modeSales": "Режим продаж",
    "modeAnalytics": "Режим аналитики",
    "languages": "Языки",
    "routing": "Логическая маршрутизация",
    "routingSupport": "Связать GPT с областью поддержки клиентов",
    "routingSales": "Связать GPT с областью продаж",
    "routingAnalytics": "Связать GPT с областью аналитики",
    "customPrompt": "Пользовательский промпт",
    "customPromptDescription": "Добавьте глобальные инструкции, которые будут добавлены ко всем промптам GPT. Используйте переменные шаблона, такие как {{customer.name}}, {{trip.date}} для персонализации.",
    "customPromptPlaceholder": "Пример: Всегда упоминайте наш бренд 'TravelPro'. Никогда не обещайте скидки без одобрения. Используйте только факты из системы.",
    "customPromptHelper": "Этот промпт будет добавлен ко всем ответам GPT. Оставьте пустым, чтобы использовать только промпты по умолчанию.",
    "managerAlert": "Настройки уведомлений менеджера",
    "managerAlertDescription": "Введите номер телефона, который будет получать автоматические уведомления об эскалации. Номер должен быть в международном формате (например, +1234567890).",
    "managerAlertPhone": "Номер телефона для уведомлений менеджера",
    "managerAlertPlaceholder": "+1234567890",
    "managerAlertHelper": "Номер телефона для получения уведомлений об эскалации (необязательно)",
    "permissions": "Разрешения",
    "permissionsDescription": "Определите, какие пользователи или отделы могут использовать помощника GPT.",
    "audience": "Аудитория",
    "audienceAll": "Все пользователи",
    "audienceRoles": "Конкретные роли",
    "audienceDepartments": "Конкретные отделы",
    "audienceUsers": "Конкретные пользователи",
    "selectSpecificBelow": "Выберите конкретные {audience} ниже",
    "selectRoles": "Выберите роли",
    "selectUsers": "Выберите пользователей",
    "selectDepartments": "Выберите отделы (очереди)",
    "noDepartmentsAvailable": "Нет доступных отделов (очередей).",
    "createQueuesFirst": "Пожалуйста, сначала создайте очереди в разделе <strong>Очереди</strong>.",
    "departmentsAvailable": "{count} отдел(ов) доступно",
    "noDepartmentsFound": "Отделы не найдены",
    "supportSettings": "Настройки поддержки",
    "maxReplyLength": "Максимальная длина ответа (символов)",
    "humanApprovalOnly": "Только человеческое одобрение (по умолчанию)",
    "salesSettings": "Настройки продаж",
    "enableUpsell": "Включить предложения допродажи",
    "maxOptions": "Максимум опций",
    "toneIntensity": "Интенсивность тона",
    "toneIntensitySoft": "Мягкий",
    "toneIntensityMedium": "Средний",
    "toneIntensityAssertive": "Уверенный",
    "analyticsSettings": "Настройки аналитики",
    "summaryLength": "Длина сводки",
    "summaryShort": "Короткая",
    "summaryMedium": "Средняя",
    "summaryLong": "Длинная",
    "redactPII": "Удалить личную информацию (PII)",
    "detectKeyIssues": "🔍 Обнаружить ключевые проблемы",
    "saveSettings": "Сохранить настройки",
    "gptAnalytics": "Аналитика GPT",
    "analyticsDashboard": "Панель аналитики",
    "analyticsDescription": "Используйте аналитику на основе GPT для получения информации о ваших операциях поддержки клиентов. Анализируйте разговоры, выявляйте закономерности и улучшайте производительность агентов.",
    "keyIssuesDetection": "Обнаружение ключевых проблем",
    "keyIssuesDescription": "Анализируйте несколько разговоров, чтобы выявить повторяющиеся проблемы, закономерности и проблемы в ваших тикетах поддержки.",
    "agentPerformanceInsights": "Информация о производительности агентов",
    "agentPerformanceDescription": "Просматривайте подробные метрики производительности для агентов, включая время отклика, пропущенные сообщения и эффективность.",
    "openAnalysis": "Открыть анализ",
    "quickAccess": "Быстрый доступ",
    "quickAccessKeyIssues": "• <strong>Ключевые проблемы:</strong> Перейдите в Настройки → GPT → Настройки аналитики → Обнаружить ключевые проблемы",
    "quickAccessAgentPerformance": "• <strong>Производительность агента:</strong> Перейдите в Пользователи → Нажмите \"Просмотр производительности\" на любом пользователе",
    "quickAccessConversationSummary": "• <strong>Сводка разговора:</strong> Откройте любой тикет → Нажмите значок документа",
    "quickAccessSentimentTrends": "• <strong>Тренды настроений:</strong> Откройте любой тикет → Нажмите значок диаграммы",
    "gptSuggestions": "✨ Предложения GPT",
    "customPromptOptional": "Пользовательский промпт (необязательно)",
    "customPromptPlaceholderModal": "Введите пользовательский промпт для направления предложений GPT. Используйте переменные шаблона, такие как {{customer.name}}, {{trip.date}}.",
    "customPromptHelperModal": "Этот промпт переопределит промпт по умолчанию для этого запроса.",
    "generating": "Генерация...",
    "generateSuggestions": "Сгенерировать предложения",
    "generatingSuggestions": "Генерация предложений...",
    "noSuggestionsAvailable": "Предложения недоступны.",
    "enterPromptAndClick": "Введите промпт и нажмите 'Сгенерировать предложения', чтобы начать.",
    "confidence": "Уверенность: {percent}%",
    "quickActions": "Быстрые действия:",
    "conversationSummary": "Сводка разговора",
    "shortSummary": "КРАТКАЯ СВОДКА",
    "extendedSummary": "РАСШИРЕННАЯ СВОДКА",
    "generatingSummary": "Генерация {type} сводки...",
    "sentiment": "Настроение: {sentiment}",
    "keyPoints": "Ключевые моменты",
    "mainTopics": "Основные темы",
    "resolution": "Решение",
    "nextActions": "Следующие действия",
    "noSummaryAvailable": "Сводка недоступна.",
    "sentimentTrends": "Тренды настроений",
    "analyzingSentimentTrends": "Анализ трендов настроений...",
    
    // Agent Performance Modal
    "agentPerformance": "Производительность агента",
    "overview": "ОБЗОР",
    "trends": "ТРЕНДЫ",
    "overallPerformanceScore": "Общий балл производительности",
    "responseTimeMetrics": "Метрики времени отклика",
    "missedMessagesMetrics": "Метрики пропущенных сообщений",
    "effectivenessMetrics": "Метрики эффективности",
    "sentimentPerformance": "Производительность настроений",
    "efficiencyProductivity": "Эффективность и продуктивность",
    "customerExperienceIndicators": "Индикаторы клиентского опыта",
    "opportunityHandling": "Обработка возможностей",
    "analyzingAgentPerformance": "Анализ производительности агента...",
    "retry": "Повторить",
    "analyze": "Анализировать",
    "clickAnalyzeToLoad": "Нажмите \"Анализировать\" для загрузки метрик производительности",
    "excellent": "Отлично",
    "veryGood": "Очень хорошо",
    "good": "Хорошо",
    "fair": "Удовлетворительно",
    "needsImprovement": "Требует улучшения",
    "average": "Среднее",
    "median": "Медиана",
    "fastest": "Самый быстрый",
    "slowest": "Самый медленный",
    "firstResponseAvg": "Первый ответ (средний)",
    "longestDelay": "Самая длинная задержка",
    "delayedResponses": "Задержанные ответы (>5 мин)",
    "totalMissed": "Всего пропущено",
    "avgPerTicket": "Среднее на тикет",
    "longestGap": "Самый длинный промежуток",
    "unansweredQuestions": "Без ответа вопросы",
    "followUpReminders": "Напоминания о последующих действиях",
    "managerAlerts": "Оповещения менеджера",
    "ticketsResolved": "Тикеты решены",
    "resolutionRate": "Процент решения",
    "avgResolutionTime": "Среднее время решения",
    "firstContactResolution": "Решение при первом контакте",
    "escalationRate": "Процент эскалации",
    "ticketsEscalated": "Тикеты эскалированы",
    "ticketsUnresolved": "Тикеты не решены",
    "negativeEndings": "Негативные окончания",
    "resolved": "Решено",
    "escalated": "Эскалировано",
    "unresolved": "Не решено",
    "positive": "Позитивный",
    "neutral": "Нейтральный",
    "negative": "Негативный",
    "recoveryRate": "Процент восстановления",
    "trend": "Тренд",
    "declining": "снижается",
    "improving": "улучшается",
    "stable": "стабильный",
    "opportunitiesMissed": "Упущено возможностей",
    "followUpsUsed": "Использовано последующих действий",
    "avgConversionLikelihood": "Средняя вероятность конверсии",
    "repeatedQuestions": "Повторяющиеся вопросы",
    "confusionCases": "Случаи путаницы",
    "backAndForthLoops": "Петли туда-сюда",
    "avgExchangesPerTicket": "Среднее обменов/тикет",
    "totalConversations": "Всего разговоров",
    "active": "Активные",
    "passive": "Пассивные",
    "avgMessageLength": "Средняя длина сообщения",
    "multitaskingScore": "Балл многозадачности",
    "responseDistribution": "Распределение ответов",
    "ticketsWithMissedMessages": "Тикеты с пропущенными сообщениями",
    "close": "ЗАКРЫТЬ",
    "exportPDF": "ЭКСПОРТ PDF",
    "exportJSON": "ЭКСПОРТ JSON",
    "refresh": "ОБНОВИТЬ",
    "user": "Пользователь",
    "sentimentTrendOverTime": "Тренд настроений во времени",
    "responseTimeDistribution": "Распределение времени отклика",
    "successRateBreakdown": "Разбивка процента успеха",
    "recommendations": "Рекомендации",
    "period": "Период",
    "avgConcurrentChats": "Среднее одновременных чатов",
    "lessThan1Min": "< 1 мин",
    "lessThan5Min": "< 5 мин",
    "moreThan15Min": "> 15 мин",
    "start": "Начало: {sentiment}",
    "end": "Конец: {sentiment}",
    "trendLabel": "Тренд: {trend}",
    "sentimentProgression": "Прогрессия настроений",
    "agent": "Агент",
    "customer": "Клиент",
    "confidencePercent": "Уверенность: {percent}%",
    "keyMoments": "Ключевые моменты",
    "noSentimentDataAvailable": "Данные настроений недоступны.",
    "salesOpportunities": "Возможности продаж",
    "analyzingSalesOpportunities": "Анализ разговора на предмет возможностей продаж...",
    "opportunitiesDetected": "Обнаруженные возможности",
    "noOpportunitiesFound": "В этом разговоре не найдено возможностей.",
    "opportunityType": "Тип",
    "readiness": "Готовность",
    "confidenceLabel": "Уверенность",
    "reasoning": "Обоснование",
    "recommendedActions": "Рекомендуемые действия",
    "suggestedMessage": "Предложенное сообщение",
    "upsell": "Допродажа",
    "crossSell": "Кросс-продажа",
    "newProduct": "Новый продукт",
    "upgrade": "Обновление",
    "addon": "Дополнение",
    "ready": "Готов",
    "interested": "Заинтересован",
    "notReady": "Не готов",
    "unknown": "Неизвестно",
    "gptFileAnalysis": "📄 Анализ файла GPT",
    "analyzingFileWithGPT": "Анализ файла с GPT...",
    "noAnalysisAvailable": "Анализ недоступен.",
  },
  
  spanish: {
    "gptAssistantSettings": "Configuración del Asistente GPT",
    "enableGPTAssistant": "Habilitar Asistente GPT",
    "functionality": "Funcionalidad",
    "functionalitySales": "Ventas",
    "functionalitySupport": "Soporte",
    "functionalityBoth": "Ambos",
    "tone": "Tono",
    "toneFormal": "Formal",
    "toneCasual": "Casual",
    "toneFriendly": "Amigable",
    "language": "Idioma",
    "languageNone": "Ninguno",
    "languageEnglish": "Inglés",
    "languageHebrew": "Hebreo (עברית)",
    "languageRussian": "Ruso (Русский)",
    "languageSpanish": "Español (Español)",
    "languageArabic": "Árabe (العربية)",
    "languageOverride": "Anulación de Idioma",
    "languageOverrideDescription": "Por defecto, GPT detecta automáticamente el idioma de la conversación. Habilite la anulación para forzar un idioma específico para todas las respuestas de GPT.",
    "enableLanguageOverride": "Habilitar Anulación de Idioma",
    "overrideLanguage": "Idioma de Anulación",
    "assistanceLevel": "Nivel de Asistencia IA",
    "assistanceSuggestions": "Solo Sugerencias",
    "assistanceSemiAuto": "Semi-Automático",
    "assistanceFull": "Completo (Requiere Aprobación Manual)",
    "modes": "Modos (Selección Múltiple)",
    "modeSupport": "Modo Soporte",
    "modeSales": "Modo Ventas",
    "modeAnalytics": "Modo Analíticas",
    "languages": "Idiomas",
    "routing": "Enrutamiento Lógico",
    "routingSupport": "Vincular GPT al Área de Soporte al Cliente",
    "routingSales": "Vincular GPT al Área de Ventas",
    "routingAnalytics": "Vincular GPT al Área de Analíticas",
    "customPrompt": "Prompt Personalizado",
    "customPromptDescription": "Agregue instrucciones globales que se agregarán a todos los prompts de GPT. Use variables de plantilla como {{customer.name}}, {{trip.date}} para personalización.",
    "customPromptPlaceholder": "Ejemplo: Siempre mencione nuestra marca 'TravelPro'. Nunca prometa descuentos sin aprobación. Use solo hechos del sistema.",
    "customPromptHelper": "Este prompt se agregará a todas las respuestas de GPT. Déjelo vacío para usar solo prompts predeterminados.",
    "managerAlert": "Configuración de Alerta del Gerente",
    "managerAlertDescription": "Ingrese el número de teléfono que recibirá alertas automáticas de escalación. El número debe estar en formato internacional (ej., +1234567890).",
    "managerAlertPhone": "Número de Teléfono de Alerta del Gerente",
    "managerAlertPlaceholder": "+1234567890",
    "managerAlertHelper": "Número de teléfono para recibir alertas de escalación (opcional)",
    "permissions": "Permisos",
    "permissionsDescription": "Defina qué usuarios o departamentos pueden usar el asistente GPT.",
    "audience": "Audiencia",
    "audienceAll": "Todos los Usuarios",
    "audienceRoles": "Roles Específicos",
    "audienceDepartments": "Departamentos Específicos",
    "audienceUsers": "Usuarios Específicos",
    "selectSpecificBelow": "Seleccione {audience} específicos a continuación",
    "selectRoles": "Seleccionar Roles",
    "selectUsers": "Seleccionar Usuarios",
    "selectDepartments": "Seleccionar Departamentos (Colas)",
    "noDepartmentsAvailable": "No hay departamentos (colas) disponibles.",
    "createQueuesFirst": "Por favor, cree colas en la sección <strong>Colas</strong> primero.",
    "departmentsAvailable": "{count} departamento(s) disponible(s)",
    "noDepartmentsFound": "No se encontraron departamentos",
    "supportSettings": "Configuración de Soporte",
    "maxReplyLength": "Longitud Máxima de Respuesta (caracteres)",
    "humanApprovalOnly": "Solo Aprobación Humana (predeterminado)",
    "salesSettings": "Configuración de Ventas",
    "enableUpsell": "Habilitar Sugerencias de Venta Adicional",
    "maxOptions": "Opciones Máximas",
    "toneIntensity": "Intensidad del Tono",
    "toneIntensitySoft": "Suave",
    "toneIntensityMedium": "Medio",
    "toneIntensityAssertive": "Asertivo",
    "analyticsSettings": "Configuración de Analíticas",
    "summaryLength": "Longitud del Resumen",
    "summaryShort": "Corto",
    "summaryMedium": "Medio",
    "summaryLong": "Largo",
    "redactPII": "Redactar Información Personal (PII)",
    "detectKeyIssues": "🔍 Detectar Problemas Clave",
    "saveSettings": "Guardar Configuración",
    "gptAnalytics": "Analíticas GPT",
    "analyticsDashboard": "Panel de Analíticas",
    "analyticsDescription": "Use analíticas impulsadas por GPT para obtener información sobre sus operaciones de soporte al cliente. Analice conversaciones, detecte patrones y mejore el rendimiento de los agentes.",
    "keyIssuesDetection": "Detección de Problemas Clave",
    "keyIssuesDescription": "Analice múltiples conversaciones para identificar problemas recurrentes, patrones y problemas en sus tickets de soporte.",
    "agentPerformanceInsights": "Información de Rendimiento del Agente",
    "agentPerformanceDescription": "Vea métricas detalladas de rendimiento para agentes, incluyendo tiempo de respuesta, mensajes perdidos y efectividad.",
    "openAnalysis": "Abrir Análisis",
    "quickAccess": "Acceso Rápido",
    "quickAccessKeyIssues": "• <strong>Problemas Clave:</strong> Vaya a Configuración → GPT → Configuración de Analíticas → Detectar Problemas Clave",
    "quickAccessAgentPerformance": "• <strong>Rendimiento del Agente:</strong> Vaya a Usuarios → Haga clic en \"Ver Rendimiento\" en cualquier usuario",
    "quickAccessConversationSummary": "• <strong>Resumen de Conversación:</strong> Abra cualquier ticket → Haga clic en el icono del documento",
    "quickAccessSentimentTrends": "• <strong>Tendencias de Sentimiento:</strong> Abra cualquier ticket → Haga clic en el icono del gráfico",
    "gptSuggestions": "✨ Sugerencias GPT",
    "customPromptOptional": "Prompt Personalizado (opcional)",
    "customPromptPlaceholderModal": "Ingrese un prompt personalizado para guiar las sugerencias de GPT. Use variables de plantilla como {{customer.name}}, {{trip.date}}.",
    "customPromptHelperModal": "Este prompt anulará el prompt predeterminado para esta solicitud.",
    "generating": "Generando...",
    "generateSuggestions": "Generar Sugerencias",
    "generatingSuggestions": "Generando sugerencias...",
    "noSuggestionsAvailable": "No hay sugerencias disponibles.",
    "enterPromptAndClick": "Ingrese un prompt y haga clic en 'Generar Sugerencias' para comenzar.",
    "confidence": "Confianza: {percent}%",
    "quickActions": "Acciones Rápidas:",
    "conversationSummary": "Resumen de Conversación",
    "shortSummary": "RESUMEN CORTO",
    "extendedSummary": "RESUMEN EXTENDIDO",
    "generatingSummary": "Generando resumen {type}...",
    "sentiment": "Sentimiento: {sentiment}",
    "keyPoints": "Puntos Clave",
    "mainTopics": "Temas Principales",
    "resolution": "Resolución",
    "nextActions": "Próximas Acciones",
    "noSummaryAvailable": "No hay resumen disponible.",
    "sentimentTrends": "Tendencias de Sentimiento",
    "analyzingSentimentTrends": "Analizando tendencias de sentimiento...",
    
    // Agent Performance Modal
    "agentPerformance": "Rendimiento del Agente",
    "overview": "RESUMEN",
    "trends": "TENDENCIAS",
    "overallPerformanceScore": "Puntuación General de Rendimiento",
    "responseTimeMetrics": "Métricas de Tiempo de Respuesta",
    "missedMessagesMetrics": "Métricas de Mensajes Perdidos",
    "effectivenessMetrics": "Métricas de Efectividad",
    "sentimentPerformance": "Rendimiento de Sentimiento",
    "efficiencyProductivity": "Eficiencia y Productividad",
    "customerExperienceIndicators": "Indicadores de Experiencia del Cliente",
    "opportunityHandling": "Manejo de Oportunidades",
    "analyzingAgentPerformance": "Analizando rendimiento del agente...",
    "retry": "Reintentar",
    "analyze": "Analizar",
    "clickAnalyzeToLoad": "Haga clic en \"Analizar\" para cargar métricas de rendimiento",
    "excellent": "Excelente",
    "veryGood": "Muy Bueno",
    "good": "Bueno",
    "fair": "Regular",
    "needsImprovement": "Necesita Mejora",
    "average": "Promedio",
    "median": "Mediana",
    "fastest": "Más Rápido",
    "slowest": "Más Lento",
    "firstResponseAvg": "Primera Respuesta (Promedio)",
    "longestDelay": "Retraso Más Largo",
    "delayedResponses": "Respuestas Retrasadas (>5m)",
    "totalMissed": "Total Perdido",
    "avgPerTicket": "Promedio por Ticket",
    "longestGap": "Brecha Más Larga",
    "unansweredQuestions": "Preguntas Sin Responder",
    "followUpReminders": "Recordatorios de Seguimiento",
    "managerAlerts": "Alertas del Gerente",
    "ticketsResolved": "Tickets Resueltos",
    "resolutionRate": "Tasa de Resolución",
    "avgResolutionTime": "Tiempo Promedio de Resolución",
    "firstContactResolution": "Resolución en Primer Contacto",
    "escalationRate": "Tasa de Escalación",
    "ticketsEscalated": "Tickets Escalados",
    "ticketsUnresolved": "Tickets No Resueltos",
    "negativeEndings": "Finales Negativos",
    "resolved": "Resuelto",
    "escalated": "Escalado",
    "unresolved": "No Resuelto",
    "positive": "Positivo",
    "neutral": "Neutral",
    "negative": "Negativo",
    "recoveryRate": "Tasa de Recuperación",
    "trend": "Tendencia",
    "declining": "en declive",
    "improving": "mejorando",
    "stable": "estable",
    "opportunitiesMissed": "Oportunidades Perdidas",
    "followUpsUsed": "Seguimientos Usados",
    "avgConversionLikelihood": "Probabilidad Promedio de Conversión",
    "repeatedQuestions": "Preguntas Repetidas",
    "confusionCases": "Casos de Confusión",
    "backAndForthLoops": "Bucles de Ida y Vuelta",
    "avgExchangesPerTicket": "Promedio de Intercambios/Ticket",
    "totalConversations": "Total de Conversaciones",
    "active": "Activo",
    "passive": "Pasivo",
    "avgMessageLength": "Longitud Promedio del Mensaje",
    "multitaskingScore": "Puntuación de Multitarea",
    "responseDistribution": "Distribución de Respuestas",
    "ticketsWithMissedMessages": "Tickets con mensajes perdidos",
    "close": "CERRAR",
    "exportPDF": "EXPORTAR PDF",
    "exportJSON": "EXPORTAR JSON",
    "refresh": "ACTUALIZAR",
    "user": "Usuario",
    "sentimentTrendOverTime": "Tendencia de Sentimiento en el Tiempo",
    "responseTimeDistribution": "Distribución de Tiempo de Respuesta",
    "successRateBreakdown": "Desglose de Tasa de Éxito",
    "recommendations": "Recomendaciones",
    "period": "Período",
    "avgConcurrentChats": "Chats Concurrentes Promedio",
    "lessThan1Min": "< 1 min",
    "lessThan5Min": "< 5 min",
    "moreThan15Min": "> 15 min",
    "start": "Inicio: {sentiment}",
    "end": "Fin: {sentiment}",
    "trendLabel": "Tendencia: {trend}",
    "sentimentProgression": "Progresión de Sentimiento",
    "agent": "Agente",
    "customer": "Cliente",
    "confidencePercent": "Confianza: {percent}%",
    "keyMoments": "Momentos Clave",
    "noSentimentDataAvailable": "No hay datos de sentimiento disponibles.",
    "salesOpportunities": "Oportunidades de Venta",
    "analyzingSalesOpportunities": "Analizando conversación para oportunidades de venta...",
    "opportunitiesDetected": "Oportunidades Detectadas",
    "noOpportunitiesFound": "No se encontraron oportunidades en esta conversación.",
    "opportunityType": "Tipo",
    "readiness": "Disposición",
    "confidenceLabel": "Confianza",
    "reasoning": "Razonamiento",
    "recommendedActions": "Acciones Recomendadas",
    "suggestedMessage": "Mensaje Sugerido",
    "upsell": "Venta Adicional",
    "crossSell": "Venta Cruzada",
    "newProduct": "Nuevo Producto",
    "upgrade": "Actualización",
    "addon": "Complemento",
    "ready": "Listo",
    "interested": "Interesado",
    "notReady": "No Listo",
    "unknown": "Desconocido",
    "gptFileAnalysis": "📄 Análisis de Archivo GPT",
    "analyzingFileWithGPT": "Analizando archivo con GPT...",
    "noAnalysisAvailable": "No hay análisis disponible.",
  },
  
  arabic: {
    "gptAssistantSettings": "إعدادات مساعد GPT",
    "enableGPTAssistant": "تفعيل مساعد GPT",
    "functionality": "الوظيفة",
    "functionalitySales": "المبيعات",
    "functionalitySupport": "الدعم",
    "functionalityBoth": "كلاهما",
    "tone": "النبرة",
    "toneFormal": "رسمي",
    "toneCasual": "غير رسمي",
    "toneFriendly": "ودود",
    "language": "اللغة",
    "languageNone": "لا شيء",
    "languageEnglish": "الإنجليزية",
    "languageHebrew": "العبرية (עברית)",
    "languageRussian": "الروسية (Русский)",
    "languageSpanish": "الإسبانية (Español)",
    "languageArabic": "العربية (العربية)",
    "languageOverride": "تجاوز اللغة",
    "languageOverrideDescription": "افتراضيًا، يكتشف GPT تلقائيًا لغة المحادثة. قم بتمكين التجاوز لإجبار لغة محددة لجميع استجابات GPT.",
    "enableLanguageOverride": "تمكين تجاوز اللغة",
    "overrideLanguage": "لغة التجاوز",
    "assistanceLevel": "مستوى المساعدة بالذكاء الاصطناعي",
    "assistanceSuggestions": "الاقتراحات فقط",
    "assistanceSemiAuto": "شبه تلقائي",
    "assistanceFull": "كامل (يتطلب الموافقة اليدوية)",
    "modes": "الأوضاع (اختيار متعدد)",
    "modeSupport": "وضع الدعم",
    "modeSales": "وضع المبيعات",
    "modeAnalytics": "وضع التحليلات",
    "languages": "اللغات",
    "routing": "التوجيه المنطقي",
    "routingSupport": "ربط GPT بمنطقة دعم العملاء",
    "routingSales": "ربط GPT بمنطقة المبيعات",
    "routingAnalytics": "ربط GPT بمنطقة التحليلات",
    "customPrompt": "موجه مخصص",
    "customPromptDescription": "أضف تعليمات عامة سيتم إلحاقها بجميع موجهات GPT. استخدم متغيرات القالب مثل {{customer.name}}, {{trip.date}} للتخصيص.",
    "customPromptPlaceholder": "مثال: اذكر دائمًا علامتنا التجارية 'TravelPro'. لا تعد أبدًا بخصومات دون موافقة. استخدم الحقائق من النظام فقط.",
    "customPromptHelper": "سيتم إضافة هذا الموجه إلى جميع استجابات GPT. اتركه فارغًا لاستخدام الموجهات الافتراضية فقط.",
    "managerAlert": "إعدادات تنبيه المدير",
    "managerAlertDescription": "أدخل رقم الهاتف الذي سيستقبل تنبيهات التصعيد التلقائية. يجب أن يكون الرقم بالتنسيق الدولي (مثل +1234567890).",
    "managerAlertPhone": "رقم هاتف تنبيه المدير",
    "managerAlertPlaceholder": "+1234567890",
    "managerAlertHelper": "رقم الهاتف لاستقبال تنبيهات التصعيد (اختياري)",
    "permissions": "الأذونات",
    "permissionsDescription": "حدد المستخدمين أو الأقسام الذين يمكنهم استخدام مساعد GPT.",
    "audience": "الجمهور",
    "audienceAll": "جميع المستخدمين",
    "audienceRoles": "أدوار محددة",
    "audienceDepartments": "أقسام محددة",
    "audienceUsers": "مستخدمون محددون",
    "selectSpecificBelow": "اختر {audience} محددًا أدناه",
    "selectRoles": "اختر الأدوار",
    "selectUsers": "اختر المستخدمين",
    "selectDepartments": "اختر الأقسام (الطوابير)",
    "noDepartmentsAvailable": "لا توجد أقسام (طوابير) متاحة.",
    "createQueuesFirst": "يرجى إنشاء طوابير في قسم <strong>الطوابير</strong> أولاً.",
    "departmentsAvailable": "{count} قسم(أقسام) متاح(ة)",
    "noDepartmentsFound": "لم يتم العثور على أقسام",
    "supportSettings": "إعدادات الدعم",
    "maxReplyLength": "الحد الأقصى لطول الرد (أحرف)",
    "humanApprovalOnly": "الموافقة البشرية فقط (افتراضي)",
    "salesSettings": "إعدادات المبيعات",
    "enableUpsell": "تفعيل اقتراحات البيع الإضافي",
    "maxOptions": "الحد الأقصى للخيارات",
    "toneIntensity": "كثافة النبرة",
    "toneIntensitySoft": "ناعم",
    "toneIntensityMedium": "متوسط",
    "toneIntensityAssertive": "حازم",
    "analyticsSettings": "إعدادات التحليلات",
    "summaryLength": "طول الملخص",
    "summaryShort": "قصير",
    "summaryMedium": "متوسط",
    "summaryLong": "طويل",
    "redactPII": "إخفاء المعلومات الشخصية (PII)",
    "detectKeyIssues": "🔍 اكتشاف المشاكل الرئيسية",
    "saveSettings": "حفظ الإعدادات",
    "gptAnalytics": "تحليلات GPT",
    "analyticsDashboard": "لوحة التحليلات",
    "analyticsDescription": "استخدم التحليلات المدعومة بـ GPT للحصول على رؤى حول عمليات دعم العملاء. حلل المحادثات واكتشف الأنماط وحسّن أداء الوكلاء.",
    "keyIssuesDetection": "اكتشاف المشاكل الرئيسية",
    "keyIssuesDescription": "حلل محادثات متعددة لتحديد المشاكل المتكررة والأنماط والمشاكل في تذاكر الدعم الخاصة بك.",
    "agentPerformanceInsights": "رؤى أداء الوكلاء",
    "agentPerformanceDescription": "عرض مقاييس الأداء التفصيلية للوكلاء بما في ذلك وقت الاستجابة والرسائل المفقودة والفعالية.",
    "openAnalysis": "فتح التحليل",
    "quickAccess": "الوصول السريع",
    "quickAccessKeyIssues": "• <strong>المشاكل الرئيسية:</strong> انتقل إلى الإعدادات → GPT → إعدادات التحليلات → اكتشاف المشاكل الرئيسية",
    "quickAccessAgentPerformance": "• <strong>أداء الوكيل:</strong> انتقل إلى المستخدمين → انقر فوق \"عرض الأداء\" على أي مستخدم",
    "quickAccessConversationSummary": "• <strong>ملخص المحادثة:</strong> افتح أي تذكرة → انقر فوق أيقونة المستند",
    "quickAccessSentimentTrends": "• <strong>اتجاهات المشاعر:</strong> افتح أي تذكرة → انقر فوق أيقونة الرسم البياني",
    "gptSuggestions": "✨ اقتراحات GPT",
    "customPromptOptional": "موجه مخصص (اختياري)",
    "customPromptPlaceholderModal": "أدخل موجهًا مخصصًا لتوجيه اقتراحات GPT. استخدم متغيرات القالب مثل {{customer.name}}, {{trip.date}}.",
    "customPromptHelperModal": "سيؤدي هذا الموجه إلى تجاوز الموجه الافتراضي لهذا الطلب.",
    "generating": "جارٍ التوليد...",
    "generateSuggestions": "إنشاء اقتراحات",
    "generatingSuggestions": "جارٍ إنشاء الاقتراحات...",
    "noSuggestionsAvailable": "لا توجد اقتراحات متاحة.",
    "enterPromptAndClick": "أدخل موجهًا وانقر فوق 'إنشاء اقتراحات' للبدء.",
    "confidence": "الثقة: {percent}%",
    "quickActions": "الإجراءات السريعة:",
    "conversationSummary": "ملخص المحادثة",
    "shortSummary": "ملخص قصير",
    "extendedSummary": "ملخص موسع",
    "generatingSummary": "جارٍ إنشاء ملخص {type}...",
    "sentiment": "المشاعر: {sentiment}",
    "keyPoints": "النقاط الرئيسية",
    "mainTopics": "المواضيع الرئيسية",
    "resolution": "الحل",
    "nextActions": "الإجراءات التالية",
    "noSummaryAvailable": "لا يوجد ملخص متاح.",
    "sentimentTrends": "اتجاهات المشاعر",
    "analyzingSentimentTrends": "جارٍ تحليل اتجاهات المشاعر...",
    "start": "البداية: {sentiment}",
    "end": "النهاية: {sentiment}",
    "trendLabel": "الاتجاه: {trend}",
    "sentimentProgression": "تطور المشاعر",
    "agent": "الوكيل",
    "customer": "العميل",
    "confidencePercent": "الثقة: {percent}%",
    "keyMoments": "اللحظات الرئيسية",
    "noSentimentDataAvailable": "لا توجد بيانات مشاعر متاحة.",
    "salesOpportunities": "فرص المبيعات",
    "analyzingSalesOpportunities": "جارٍ تحليل المحادثة لفرص المبيعات...",
    "noOpportunitiesFound": "لم يتم العثور على فرص في هذه المحادثة.",
    "opportunityType": "النوع",
    "readiness": "الاستعداد",
    "confidenceLabel": "الثقة",
    "reasoning": "المنطق",
    "recommendedActions": "الإجراءات الموصى بها",
    "suggestedMessage": "الرسالة المقترحة",
    "upsell": "البيع الإضافي",
    "crossSell": "البيع المتقاطع",
    "newProduct": "منتج جديد",
    "upgrade": "ترقية",
    "addon": "إضافة",
    "ready": "جاهز",
    "interested": "مهتم",
    "notReady": "غير جاهز",
    "unknown": "غير معروف",
    "gptFileAnalysis": "📄 تحليل الملف GPT",
    "analyzingFileWithGPT": "جارٍ تحليل الملف باستخدام GPT...",
    "noAnalysisAvailable": "لا يوجد تحليل متاح.",
    
    // Agent Performance Modal
    "agentPerformance": "أداء الوكيل",
    "overview": "نظرة عامة",
    "trends": "الاتجاهات",
    "overallPerformanceScore": "نقاط الأداء الإجمالية",
    "responseTimeMetrics": "مقاييس وقت الاستجابة",
    "missedMessagesMetrics": "مقاييس الرسائل المفقودة",
    "effectivenessMetrics": "مقاييس الفعالية",
    "sentimentPerformance": "أداء المشاعر",
    "efficiencyProductivity": "الكفاءة والإنتاجية",
    "customerExperienceIndicators": "مؤشرات تجربة العملاء",
    "opportunityHandling": "معالجة الفرص",
    "analyzingAgentPerformance": "جارٍ تحليل أداء الوكيل...",
    "retry": "إعادة المحاولة",
    "analyze": "تحليل",
    "clickAnalyzeToLoad": "انقر فوق \"تحليل\" لتحميل مقاييس الأداء",
    "excellent": "ممتاز",
    "veryGood": "جيد جدًا",
    "good": "جيد",
    "fair": "عادل",
    "needsImprovement": "يحتاج إلى تحسين",
    "average": "متوسط",
    "median": "الوسيط",
    "fastest": "الأسرع",
    "slowest": "الأبطأ",
    "firstResponseAvg": "أول استجابة (متوسط)",
    "longestDelay": "أطول تأخير",
    "delayedResponses": "الردود المتأخرة (>5 دقيقة)",
    "totalMissed": "إجمالي المفقود",
    "avgPerTicket": "متوسط لكل تذكرة",
    "longestGap": "أطول فجوة",
    "unansweredQuestions": "الأسئلة غير المجابة",
    "followUpReminders": "تذكيرات المتابعة",
    "managerAlerts": "تنبيهات المدير",
    "ticketsResolved": "التذاكر المحلولة",
    "resolutionRate": "معدل الحل",
    "avgResolutionTime": "متوسط وقت الحل",
    "firstContactResolution": "حل الاتصال الأول",
    "escalationRate": "معدل التصعيد",
    "ticketsEscalated": "التذاكر المتصاعدة",
    "ticketsUnresolved": "التذاكر غير المحلولة",
    "negativeEndings": "النهايات السلبية",
    "resolved": "محلول",
    "escalated": "متصاعد",
    "unresolved": "غير محلول",
    "positive": "إيجابي",
    "neutral": "محايد",
    "negative": "سلبي",
    "recoveryRate": "معدل التعافي",
    "trend": "الاتجاه",
    "declining": "آخذ في الانخفاض",
    "improving": "يتحسن",
    "stable": "مستقر",
    "opportunitiesDetected": "الفرص المكتشفة",
    "opportunitiesMissed": "الفرص المفقودة",
    "followUpsUsed": "المتابعات المستخدمة",
    "avgConversionLikelihood": "متوسط احتمالية التحويل",
    "repeatedQuestions": "الأسئلة المتكررة",
    "confusionCases": "حالات الارتباك",
    "backAndForthLoops": "حلقات ذهابًا وإيابًا",
    "avgExchangesPerTicket": "متوسط التبادلات/التذكرة",
    "totalConversations": "إجمالي المحادثات",
    "active": "نشط",
    "passive": "سلبي",
    "avgMessageLength": "متوسط طول الرسالة",
    "multitaskingScore": "نقاط تعدد المهام",
    "responseDistribution": "توزيع الاستجابة",
    "ticketsWithMissedMessages": "التذاكر مع الرسائل المفقودة",
    "close": "إغلاق",
    "exportPDF": "تصدير PDF",
    "exportJSON": "تصدير JSON",
    "refresh": "تحديث",
    "user": "المستخدم",
    "sentimentTrendOverTime": "اتجاه المشاعر بمرور الوقت",
    "responseTimeDistribution": "توزيع وقت الاستجابة",
    "successRateBreakdown": "تفصيل معدل النجاح",
    "recommendations": "التوصيات",
    "period": "الفترة",
    "avgConcurrentChats": "متوسط الدردشات المتزامنة",
    "lessThan1Min": "< 1 دقيقة",
    "lessThan5Min": "< 5 دقائق",
    "moreThan15Min": "> 15 دقيقة",
  }
};

// Helper function to get translation based on GPT language setting
export const getGPTTranslation = (key, language = "english", params = {}) => {
  const lang = language || "english";
  const langKey = lang.toLowerCase();
  
  // Debug logging for translation lookup (only for missing translations)
  if (!translations[langKey]?.[key] && langKey !== "english") {
    console.warn(`[getGPTTranslation] Translation not found for key "${key}" in language "${langKey}", using English fallback`);
  }
  
  const translation = translations[langKey]?.[key] || translations.english[key] || key;
  
  // Replace placeholders like {param}
  return translation.replace(/\{(\w+)\}/g, (match, paramKey) => {
    return params[paramKey] !== undefined ? params[paramKey] : match;
  });
};

// Map i18n language codes to GPT language names
export const mapI18nToGPTLanguage = (i18nLang) => {
  if (!i18nLang) {
    console.log("mapI18nToGPTLanguage: i18nLang is empty, checking localStorage");
    try {
      const storedLang = localStorage.getItem("language");
      console.log("mapI18nToGPTLanguage: localStorage language =", storedLang);
      if (storedLang) {
        const lang = storedLang.toLowerCase();
        if (lang.startsWith("es") || lang === "es") return "spanish";
        if (lang.startsWith("he") || lang.startsWith("iw") || lang === "he") return "hebrew";
        if (lang.startsWith("ru") || lang === "ru") return "russian";
        if (lang.startsWith("ar") || lang === "ar") return "arabic";
      }
    } catch (e) {
      console.warn("Error reading localStorage:", e);
    }
    console.log("mapI18nToGPTLanguage: no language found, defaulting to english");
    return "english";
  }
  const lang = i18nLang.toLowerCase();
  console.log("mapI18nToGPTLanguage: mapping", i18nLang, "to GPT language");
  if (lang.startsWith("es") || lang === "es") return "spanish";
  if (lang.startsWith("he") || lang.startsWith("iw") || lang === "he") return "hebrew";
  if (lang.startsWith("ru") || lang === "ru") return "russian";
  if (lang.startsWith("ar") || lang === "ar") return "arabic";
  console.log("mapI18nToGPTLanguage: language not recognized, defaulting to english");
  return "english";
};

// Get initial language from i18n (for useState initialization)
export const getInitialLanguageFromI18n = () => {
  try {
    const { i18n } = require("../translate/i18n");
    const mappedLang = mapI18nToGPTLanguage(i18n.language);
    console.log("[getInitialLanguageFromI18n] Initial language:", { i18nLang: i18n.language, mappedLang });
    return mappedLang;
  } catch (e) {
    console.warn("[getInitialLanguageFromI18n] Error, defaulting to english:", e);
    return "english";
  }
};

// Helper to get current GPT language from settings, with i18n fallback
export const getGPTLanguage = async (companyId) => {
  try {
    // Use dynamic import with correct path (utils/ -> services/)
    const apiGptModule = await import("../services/apiGpt");
    const { getGPTSettings } = apiGptModule;
    const settings = await getGPTSettings();
    
    console.log("[getGPTLanguage] Settings loaded:", {
      languageOverrideEnabled: settings?.languageOverrideEnabled,
      languageOverride: settings?.languageOverride,
      languages: settings?.languages,
      language: settings?.language
    });
    
    // Priority 1: Language Override (if enabled)
    if (settings?.languageOverrideEnabled && settings?.languageOverride && settings.languageOverride.trim() !== "") {
      console.log("[getGPTLanguage] Using language override:", settings.languageOverride);
      return settings.languageOverride;
    }
    
    // Priority 2: Languages array (single select - take first element)
    // Check if languages array is NOT empty
    const hasLanguagesArray = Array.isArray(settings?.languages) && settings.languages.length > 0 && settings.languages[0];
    
    if (hasLanguagesArray) {
      const langCode = String(settings.languages[0]).toLowerCase();
      console.log("[getGPTLanguage] Languages array has value:", langCode);
      // Map language codes to GPT language names
      if (langCode === "en") return "english";
      if (langCode === "he") return "hebrew";
      if (langCode === "ru") return "russian";
      if (langCode === "es") return "spanish";
      if (langCode === "ar") return "arabic";
    }
    
    // If languages array is empty, ALWAYS use i18n language (system language)
    // Don't check settings.language if languages array is empty
    if (!hasLanguagesArray) {
      const { i18n } = await import("../translate/i18n");
      const i18nLang = i18n.language || localStorage.getItem("language") || "en";
      const mappedLang = mapI18nToGPTLanguage(i18nLang);
      console.log("[getGPTLanguage] Languages array is empty, using i18n fallback:", { 
        i18nLang, 
        mappedLang,
        languagesArray: settings?.languages,
        languageSetting: settings?.language
      });
      return mappedLang;
    }
    
    // Priority 3: Explicit language setting (only if languages array was not empty but no match found)
    // This should rarely happen, but keep as fallback
    if (settings?.language && settings.language.trim() !== "" && settings.language !== "english") {
      console.log("[getGPTLanguage] Using explicit language setting:", settings.language);
      return settings.language;
    }
    
    // Final fallback to i18n language (system language)
    const { i18n } = await import("../translate/i18n");
    const i18nLang = i18n.language || localStorage.getItem("language") || "en";
    const mappedLang = mapI18nToGPTLanguage(i18nLang);
    console.log("[getGPTLanguage] Final fallback to i18n:", { i18nLang, mappedLang });
    return mappedLang;
  } catch (error) {
    console.warn("Error loading GPT settings for language:", error);
    // Fallback to i18n language
    try {
      const { i18n } = await import("../translate/i18n");
      const i18nLang = i18n.language;
      const mappedLang = mapI18nToGPTLanguage(i18nLang);
      console.log("[getGPTLanguage] Error fallback to i18n:", { i18nLang, mappedLang });
      return mappedLang;
    } catch (e) {
      console.warn("[getGPTLanguage] Final fallback to english:", e);
      return "english";
    }
  }
};

// Helper to get current language synchronously (for use in components)
export const getCurrentGPTLanguage = (gptLanguage, gptLanguageOverrideEnabled, gptLanguageOverride) => {
  if (gptLanguageOverrideEnabled && gptLanguageOverride && gptLanguageOverride.trim() !== "") {
    console.log("getCurrentGPTLanguage: using override", gptLanguageOverride);
    return gptLanguageOverride;
  }
  // If language is explicitly set and not empty, use it
  // But if it's null, undefined, or empty string, use i18n fallback
  if (gptLanguage && gptLanguage.trim() !== "") {
    console.log("getCurrentGPTLanguage: using gptLanguage", gptLanguage);
    return gptLanguage;
  }
  // Fallback to i18n language
  try {
    // Use require for synchronous access
    const i18nModule = require("../translate/i18n");
    const { i18n } = i18nModule;
    const mappedLang = mapI18nToGPTLanguage(i18n.language);
    console.log("getCurrentGPTLanguage: using i18n fallback", i18n.language, "->", mappedLang);
    return mappedLang;
  } catch (e) {
    console.warn("getCurrentGPTLanguage: error getting i18n, using english", e);
    return "english";
  }
};

export default translations;










